
const CRITERIA_LABEL_MAP: Record<string, string> = {
  states: 'Admin Level 1',
  town: 'Admin Level 2',
  township: 'Admin Level 3',
};

export const adaptCriteriaLabel = (key: string, originalName: string): string => {
  return CRITERIA_LABEL_MAP[key] ?? originalName;
};


export const adaptCriteriaList = <T extends { key: string; name: string }>(
  criterias: T[],
): T[] => {
  return criterias.map((criteria) => ({
    ...criteria,
    name: adaptCriteriaLabel(criteria.key, criteria.name),
  }));
};
